export const DESKTOP_BP = '(max-width: 1024px)';
